import { toast } from "@payezy/ui";
import { isStepUp, problemMessage, reauthenticate } from "./api";

export function showError(e: unknown) {
  if (isStepUp(e)) {
    toast.error("Sign in again to confirm this privileged operation.", { action: { label: "Re-authenticate", onClick: reauthenticate } });
    return;
  }
  toast.error(problemMessage(e));
}
